import { ConditionSetSchemaPlugin, ConditionXmlNodeName } from '@common/flare-data/plugins/condition-set-schema.plugin';
import { FlareDataCommentSchemaPlugin } from '@common/flare-data/plugins/flare-data-comment-schema.plugin';
import { FlareDataUnknownSchemaPlugin } from '@common/flare-data/plugins/flare-data-unknown-schema.plugin';
import { CustomAttributesSchemaPlugin } from '@common/flare/schema/custom-attributes-schema-plugin';
import { TextSchemaPlugin } from '@common/flare/schema/text-schema.plugin';
import { SimpleDomDocument } from '@common/html/simple-dom/node';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { FlareDataSchema } from './flare-data-schema';

export class ConditionSetSchema extends FlareDataSchema {

  get name(): string { return 'conditionset'; }
  get version(): string { return '0.1.0'; }

  constructor(createGuid?: () => string) {
    const schemaPlugins: SchemaPlugin[] = [
      new ConditionSetSchemaPlugin(), // all nodes should be configured as block-type nodes to be compatible with comments and unknown nodes
      new TextSchemaPlugin(), // add 'text' node due to prosemirror requirements
      new FlareDataCommentSchemaPlugin(), // add 'comment' as block-type node to support xml comments in the conditions document
      new FlareDataUnknownSchemaPlugin(), // add unknown tags as block-type nodes that are not managed by the conditions editor to allow them in the conditions document
      new CustomAttributesSchemaPlugin(), // support custom attributes in the conditions document
    ];

    super(schemaPlugins, createGuid);
  }

  public validateXmlDoc(xmlDoc: SimpleDomDocument): void {
    this.validateRootElement(xmlDoc, ConditionXmlNodeName.Set);

    const rootElement = xmlDoc.documentElement;
    const usedNames = [];
    const items = rootElement.getElementsByTagName(ConditionXmlNodeName.Tag);
    for (const item of items) {
      const conditionalTagName = item.getAttribute('Name');
      if (conditionalTagName === null)
        throw new Error(`Condition tag with undefined 'Name' attribute found.`);
      if (!conditionalTagName.trim())
        throw new Error(`Condition tag with empty 'Name' attribute found.`);
      if (usedNames.includes(conditionalTagName))
        throw new Error(`Condition tag with duplicate 'Name' attribute found: '${conditionalTagName}'.`);
      usedNames.push(conditionalTagName);
    }
  }

}
